import logoMeli from "../assets/images/logo_meli.svg";
import logoPago from "../assets/images/logo_pago.png";

// Hosts that should display the alternate (logo_pago) logo
const PAGO_HOSTS = ["casemanager.denunciasbanco.com.mx"];

// Whether the current host is a MercadoPago instance.
export const isPago = () => {
  const host = typeof window !== "undefined" ? window.location.hostname : "";
  return PAGO_HOSTS.includes(host);
};

// Returns the logo to use based on the current hostname.
export const getLogo = () => {
  return isPago() ? logoPago : logoMeli;
};
